import { useState, useCallback } from "react";
import { message } from "antd";
import apiClient from "utils/apiClient";

const IDENTITY_BASE = "/identity-service/api/v1";

export function useWorkspaceIdentity() {
  const [workspace, setWorkspace] = useState(null);
  const [ownerEmail, setOwnerEmail] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchWorkspaceIdentity = useCallback(async (workspaceId) => {
    if (!workspaceId) return;
    setLoading(true);
    setWorkspace(null);
    setOwnerEmail(null);
    try {
      const { data } = await apiClient.get(`${IDENTITY_BASE}/workspaces/${workspaceId}`);
      setWorkspace(data);

      const owner = (data?.users ?? []).find((m) =>
        (m.roleNames ?? []).includes("OWNER"),
      );
      // ASSUMPTION: identity-service's UserDTO exposes an `email` field —
      // adjust if the real accessor is named differently.
      setOwnerEmail(owner?.user?.email ?? null);
    } catch {
      message.error("Failed to load workspace details");
    } finally {
      setLoading(false);
    }
  }, []);

  return { workspace, ownerEmail, loading, fetchWorkspaceIdentity };
}